<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="zeroStateRows"
      styleClass="vgt-table striped"
      row-style-class="blur-row"
      style="width: 100%;"
    >
      <template slot="table-row" slot-scope="zeroStateRows">
        <span v-if="zeroStateRows.column.field === 'status'">
          <a>Delivered</a>
        </span>
        <span v-else-if="zeroStateRows.column.field === 'details'">
          <a>Details</a>
        </span>
      </template>

      <div class="vgt-center-align vgt-text-disabled" slot="emptystate">
        There are no items to display
      </div>
    </vue-good-table>

    <router-link
      tag="button"
      :to="{ name: 'GiftList' }"
      class="button-gemnote button-gemnote--medium send-gift"
      >Send a gift here</router-link
    >
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
export default {
  name: 'OrderListZeroState',
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: 'Date',
          field: 'createdAt'
        },
        {
          label: 'Order #',
          field: 'id'
        },
        {
          label: 'Recipient',
          field: 'recipient'
        },
        {
          label: 'Sender Email',
          field: 'senderEmail'
        },
        {
          label: 'Ship Status',
          field: 'status'
        },
        {
          label: 'Details',
          field: 'details'
        }
      ],
      zeroStateRows: []
    }
  }
}
</script>

<style lang="scss" scoped>
h5 {
  margin: 3rem;
}

.send-gift {
  height: 3.25rem;
  margin-top: 100px;
  width: auto;
  font-size: 0.875rem !important;
}

.vgt-text-disabled {
  color: #24292c;
  padding: 10px;
}
</style>
